export default "__VITE_ASSET__Nv_05rQ9__"